module.exports = __webpack_public_path__ + "img/_tuurro.t6.rb.8a0188a8.png";